import styled from 'styled-components';

import Button from '../../../../components/Button';
import datePicker from '../../../../assets/images/date-picker.svg';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: ${(props) => props.theme.colors.white};
  border-radius: 6px;
  line-height: 18px;
  margin: 55px 0;
  max-width: 560px;
  padding: 45px 40px;

  h1 {
    text-align: center;
    font-size: 18px;
    font-weight: 600;
  }

  h2 {
    font-size: 14px;
    font-weight: 400;
    margin-top: 15px;
    text-align: center;
  }

  p {
    color: #a6a3a3;
    font-size: 12px;
    margin-top: 20px;
  }

  form {
    display: flex;
    flex-direction: column;
    margin-top: 20px;
    min-width: 320px;
  }
`;

/**
 * O termo é longo (~5.600 caracteres em produção), então ele rola dentro do próprio bloco:
 * empurrar o botão de concluir para fora da tela esconderia o que a pessoa precisa fazer
 * depois de ler.
 */
export const ConsentTerm = styled.div`
  background-color: ${(props) => props.theme.colors.gray4};
  border-radius: 6px;
  color: ${(props) => props.theme.colors.graySecondary};
  font-size: 12px;
  line-height: 20px;
  max-height: 260px;
  overflow-y: auto;
  padding: 20px;
  text-align: justify;
  white-space: pre-wrap;
`;

export const Accept = styled.div`
  align-items: center;
  display: flex;
  margin-top: 20px;

  span {
    font-size: 13px;
    margin-left: 10px;
  }
`;

export const ResponsibleBlock = styled.div`
  border-bottom: 1px solid ${(props) => props.theme.colors.gray4};
  display: flex;
  flex-direction: column;
  padding-bottom: 25px;

  > p {
    margin-top: 0;
  }
`;

export const Field = styled.div`
  font-size: 14px;

  .datepicker {
    color: ${(props) => props.theme.colors.graySecondary};

    &::-webkit-calendar-picker-indicator {
      background: url(${datePicker}) no-repeat;
    }
  }

  & + div {
    margin-top: 20px;
  }

  > div {
    height: 40px;
    margin-top: 5px;
  }

  input {
    font-size: 14px;
  }
`;

export const ShowTermButton = styled(Button)`
  align-self: center;
  font-size: 14px;
  margin-top: 25px !important;
  min-width: 152px;
  text-transform: none;
`;

export const SaveButton = styled(Button)`
  align-self: center;
  font-size: 14px;
  margin-top: 35px !important;
  min-width: 152px;
  text-transform: none;
`;
